/* eslint-disable */
import React from 'react';
import { FormInput } from "../../../components";

function CreditRow({ number, pmEval }) {

    const documentkey = `evaluationOfCreditHistoryP${number}document`;
    const pmEvalDocument = pmEval?.evaluationOfCreditHistory?.[documentkey];
    const scheduleKey = `evaluationOfCreditHistoryP${number}schedule`;
    const pmEvalSchedule = pmEval?.evaluationOfCreditHistory?.[scheduleKey];
    const paymentKey = `evaluationOfCreditHistoryP${number}payment`;
    const pmEvalPayment = pmEval?.evaluationOfCreditHistory?.[paymentKey];
    const missedKey = `evaluationOfCreditHistoryP${number}missed`;
    const pmEvalMissed = pmEval?.evaluationOfCreditHistory?.[missedKey];


    return (
        <tr className="px-4 py-6 border-b hover:bg-gray-100">
            <td className='px-4 py-3'>{number}</td>
            <td className='px-4 py-3'>
                <FormInput 
                    type="text" 
                    name={`evaluationOfCreditHistoryP${number}document`} 
                    id={`evaluationOfCreditHistoryP${number}document`} 
                    value={pmEval && pmEvalDocument}
                    disabled={pmEval ? true : false}
                />
            </td>
            <td className='px-4 py-3'>
                <FormInput 
                    type="text" 
                    name={`evaluationOfCreditHistoryP${number}schedule`} 
                    id={`evaluationOfCreditHistoryP${number}schedule`}
                    value={pmEval && pmEvalSchedule}
                    disabled={pmEval ? true : false}
                />
            </td>
            <td className='px-4 py-3'>
                <FormInput 
                    type="text" 
                    name={`evaluationOfCreditHistoryP${number}payment`} 
                    id={`evaluationOfCreditHistoryP${number}payment`}
                    value={pmEval && pmEvalPayment}
                    disabled={pmEval ? true : false}
                />
            </td>
            <td className='px-4 py-3'>
                <FormInput 
                    type="text" 
                    name={`evaluationOfCreditHistoryP${number}missed`} 
                    id={`evaluationOfCreditHistoryP${number}missed`}
                    value={pmEval && pmEvalMissed}
                    disabled={pmEval ? true : false}
                />
            </td>
        </tr>
    )
}

export default CreditRow